import React, { useState } from "react";
import { PackagePlus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { compressImage } from "@/lib/image";

export const ProductPicker = ({ image, name, onImage, onName, testId = "product" }) => {
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("الملف ليس صورة");
    if (file.size > 15 * 1024 * 1024) return toast.error("حجم الصورة كبير جداً");
    setBusy(true);
    try { await onImage(await compressImage(file)); } catch { toast.error("تعذّر قراءة الصورة"); }
    setBusy(false);
  };

  return (
    <div data-testid={`${testId}-picker`}>
      <Label className="mb-2 block">صورة المنتج <span className="text-muted-foreground text-xs">(اختياري)</span></Label>
      <div className="flex items-center gap-3">
        {image ? (
          <div className="relative shrink-0">
            <img src={image} alt="product" className="w-14 h-14 rounded-xl object-cover border border-border" data-testid={`${testId}-preview`} />
            <button type="button" onClick={() => onImage("")} data-testid={`${testId}-remove`}
              className="absolute -top-2 -end-2 w-5 h-5 rounded-full bg-destructive text-white flex items-center justify-center">
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : null}
        <label className="cursor-pointer shrink-0" data-testid={`${testId}-upload-label`}>
          <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testId}-upload-input`} />
          <div className="flex items-center gap-2 justify-center rounded-xl border border-dashed border-border bg-secondary px-3 py-2.5 text-sm text-muted-foreground hover:border-primary/40 transition-colors">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <PackagePlus className="w-4 h-4" />}
            {image ? "تغيير" : "رفع المنتج"}
          </div>
        </label>
        {image && (
          <Input value={name || ""} onChange={(e) => onName(e.target.value)} placeholder="اسم المنتج (اختياري)"
            className="bg-secondary border-border" data-testid={`${testId}-name-input`} />
        )}
      </div>
      <p className="text-[11px] text-muted-foreground mt-1.5">
        {image ? "سيكون المنتج محور الصور والفيديوهات ونصوصها ضمن الحملة" : "ارفع صورة منتج ليكون هو محور الصورة أو الفيديو"}
      </p>
    </div>
  );
};
